import React from 'react';
import { EventPicker } from '@v2/components/ui/EventPicker';
import { fields } from '../constants';
import { Controller } from 'react-hook-form';
import { GoalEventPickerProps } from '../types';
import { isNull } from 'lodash';

export const GoalEventPicker = ({
  control,
  eventSet: objectiveGoalEventSet,
  value,
  ...props
}: GoalEventPickerProps) => {
  return (
    <Controller
      control={control}
      name={fields.objectiveGoalEvent.path}
      render={({ field, fieldState }) => {
        return (
          <EventPicker
            {...field}
            {...fieldState}
            {...props}
            id={value}
            value={isNull(field.value) ? '' : field.value}
            InputLabelProps={{ shrink: !!field.value }}
            label="Goal Event"
            helperText={fieldState.error?.message}
            eventSet={objectiveGoalEventSet}
          />
        );
      }}
    />
  );
};
